import React, { useEffect } from 'react';
import getDefaultHomePageContent from '../hooks/staticQueries/useGetHomePageContent';
import HomePage from '../templates/homePage/homePage';

export default function IndexPage() {
  const defaultHomePageContent = getDefaultHomePageContent();

  // TODO: Delete when all Google Ads are linked to new URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const search = params.get('search');

    if (search) {
      params.delete('search');
      const redirectUrl = `/booking/${encodeURIComponent(search)}/?${params.toString()}`;

      requestAnimationFrame(() => {
        window.location.replace(redirectUrl);
      });
    }
  }, []);

  if (!defaultHomePageContent) {
    return null;
  }

  return (<HomePage pageContext={{ content: defaultHomePageContent }} />);
}
